import { ActivityCategory, asActivityCategory, TaskTypeId } from "@sp-crm/core";
import { useGetTaskTypesQuery } from "generated/graphql";
import { stableQueryOptions } from "util/requests";

export interface ActivityTypeOption {
    id: TaskTypeId;
    name: string;
    category: ActivityCategory;
    isArchived: boolean;
}

export const noActivityTypeKey = "";

export const chooseActivityTypeLabel = "Choose an activity type";

export const activityTypeChoices = (
    options: ActivityTypeOption[],
    category: ActivityCategory,
    selectedTypeId: TaskTypeId | null,
): ActivityTypeOption[] =>
    options.filter(
        option =>
            option.category === category &&
            (!option.isArchived || option.id === selectedTypeId),
    );

export const useActivityTypeOptions = (): ActivityTypeOption[] => {
    const query = useGetTaskTypesQuery({}, stableQueryOptions());
    return (query.data?.getTaskTypes ?? []).map(taskType => ({
        id: taskType.id,
        name: taskType.name,
        category: asActivityCategory(taskType.category),
        isArchived: taskType.isArchived,
    }));
};
